import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { TicketCategory } from "../../data/helpCenterData";

interface TicketSuccessModalProps {
  isOpen: boolean;
  ticketNumber: string;
  email: string;
  selectedCategory: TicketCategory | null;
  onSubmitAnother: () => void;
}

const TicketSuccessModal = ({
  isOpen,
  ticketNumber,
  email,
  selectedCategory,
  onSubmitAnother,
}: TicketSuccessModalProps) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 text-center"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-white" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Ticket Submitted!
        </h2>
        <p className="text-gray-600 mb-6">
          Your support ticket has been submitted successfully. We'll get back to
          you as soon as possible.
        </p>

        <div className="bg-gray-50 rounded-xl p-4 mb-6">
          <p className="text-sm text-gray-500 mb-1">Your Ticket Number</p>
          <p className="text-xl font-bold text-[#8B52FF] font-mono">
            {ticketNumber}
          </p>
        </div>

        <div className="text-sm text-gray-500 mb-6">
          <p>
            A confirmation email has been sent to{" "}
            <span className="font-medium text-gray-700">{email}</span>
          </p>
          <p className="mt-2">
            Expected response time:{" "}
            <span className="font-medium text-gray-700">
              {selectedCategory?.responseTime}
            </span>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onSubmitAnother}
            className="flex-1 px-6 py-3 rounded-xl border border-gray-200 text-gray-700 font-medium hover:bg-gray-50 transition-colors"
          >
            Submit Another
          </button>
          <Link
            to="/"
            className="flex-1 px-6 py-3 rounded-xl bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold hover:shadow-lg transition-all text-center"
          >
            Back to Home
          </Link>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default TicketSuccessModal;
